export default {
  isShown: (state) => state.isShown,
  externalPanelId: (state) => state.externalPanelId,
  billings: (state) => state.billings,
  search: (state) => state.search,
};
